import { useEffect, useState } from "react";
import { Button, Card, Form, Row, Col } from "react-bootstrap";
import API from "../api";
import axios from "axios";
import { Tree, TreeNode } from "react-organizational-chart";
import styled from "styled-components";

const Organigrama = () => {
  const [estructura, setEstructura] = useState([]);
  const [usuariosDisponibles, setUsuariosDisponibles] = useState([]);
  const [nuevoUsuario, setNuevoUsuario] = useState("");
  const [padreSeleccionado, setPadreSeleccionado] = useState(null);
  const [mostrarGuardarAgregar, setMostrarGuardarAgregar] = useState(false);
  const [mostrarGuardarQuitar, setMostrarGuardarQuitar] = useState(false);

  // 1. Obtener estructura del organigrama
  useEffect(() => {
    axios.get(`${API}/estructura_organigrama`).then((res) => {
      if (res.data.exito) {
        console.log("Estructura cargada:", res.data.estructura);
        setEstructura(res.data.estructura);
      }
    });
  }, []);

  // 2. Obtener usuarios disponibles
  useEffect(() => {
    axios.get(`${API}/usuarios_disponibles_organigrama`).then((res) => {
      if (res.data.exito) {
        setUsuariosDisponibles(res.data.usuarios);
      }
    });
  }, []);

  // 3. Agregar nuevo usuario al organigrama
  const agregarUsuario = () => {
    if (!nuevoUsuario) return;

    const usuario = usuariosDisponibles.find((u) => u._id === nuevoUsuario);
    if (!usuario) return;

    const nuevoNodo = {
      usuario_id: usuario._id,
      Usuario: usuario.Usuario,
      nombre: `${usuario.Nombre} ${usuario["Apellido Paterno"]}`,
      cargo: usuario.Cargo || "Sin Cargo",
      padre_id: padreSeleccionado,
    };
    console.log("Nuevo nodo a agregar:", nuevoNodo);

    setEstructura([...estructura, nuevoNodo]);
    setUsuariosDisponibles(usuariosDisponibles.filter((u) => u._id !== nuevoUsuario));
    setNuevoUsuario("");
    setPadreSeleccionado(null);
    setMostrarGuardarAgregar(true);  // Mostrar guardar al lado de Agregar
  };

    // 4. Guardar estructura en backend
    const guardarEstructura = () => {
    const estructuraValida = estructura.every(n => 
        n.usuario_id && n.cargo && (typeof n.nombre === 'string') && 'padre_id' in n && n.Usuario
    );

    if (!estructuraValida) {
        alert("Hay nodos incompletos. Verifica la información.");
        return;
    }

    axios.post(`${API}/estructura_organigrama`, { estructura })
        .then((res) => {
        if (res.data.exito) {
            alert("Organigrama guardado exitosamente.");
        }
        })
        .catch((err) => console.error("Error al guardar:", err));
    };

  const [usuarioAQuitar, setUsuarioAQuitar] = useState("");

    const quitarUsuario = () => {
    if (!usuarioAQuitar) return;

    const confirmado = window.confirm("¿Deseas quitar este usuario?");
    if (!confirmado) return;

    setEstructura(estructura.filter((n) => n.usuario_id !== usuarioAQuitar));
    setUsuarioAQuitar("");
    setMostrarGuardarQuitar(true);  // Mostrar guardar al lado de Quitar
    };

    // Nodo con bordes y estilo
    const StyledNode = styled.div`
    padding: 10px;
    border-radius: 8px;
    display: inline-block;
    border: 1px solid #999;
    background-color: #f8f9fa;
    font-weight: bold;
    text-align: center;
    width: 180px;
    `;

    const renderTree = (padreId = null) => {
    const nodos = estructura.filter((nodo) => nodo.padre_id === padreId);
    if (nodos.length === 0) return null;

    return nodos.map((nodo) => (
        <TreeNode
        key={nodo.usuario_id}
        label={<StyledNode>{nodo.cargo}<br />{nodo.nombre}</StyledNode>}
        >
        {renderTree(nodo.usuario_id)}
        </TreeNode>
    ));
    };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-4">Administrar Organigrama</h4>

      {/* Formulario para agregar usuario */}
        <Card className="mb-4">
        <Card.Body>

            {/* AGREGAR USUARIO */}
            <Row className="align-items-end mb-4">
            <Col md={5}>
                <Form.Group>
                <Form.Label>Seleccionar usuario</Form.Label>
                <Form.Select
                    value={nuevoUsuario}
                    onChange={(e) => setNuevoUsuario(e.target.value)}
                >
                    <option value="">-- Seleccione --</option>
                    {usuariosDisponibles.map((u) => (
                    <option key={u._id} value={u._id}>
                        {u.Nombre} {u["Apellido Paterno"]} ({u.Cargo})
                    </option>
                    ))}
                </Form.Select>
                </Form.Group>
            </Col>
            <Col md={5}>
                <Form.Group>
                <Form.Label>Depende de</Form.Label>
                <Form.Select
                    value={padreSeleccionado || ""}
                    onChange={(e) => setPadreSeleccionado(e.target.value)}
                >
                    <option value="">-- Sin superior --</option>
                    {estructura.map((n, i) => (
                    <option key={i} value={n.usuario_id}>
                        {n.cargo} - {n.nombre}
                    </option>
                    ))}
                </Form.Select>
                </Form.Group>
            </Col>
            <Col md={2} className="d-flex gap-2">
                <Button variant="success" className="w-100" onClick={agregarUsuario}>
                Agregar
                </Button>
                {mostrarGuardarAgregar && (
                <Button
                    variant="primary"
                    onClick={() => {
                    guardarEstructura();
                    setMostrarGuardarAgregar(false);
                    }}
                >
                    Guardar
                </Button>
                )}
            </Col>
            </Row>

            <hr />

            {/* QUITAR USUARIO */}
            <Row className="align-items-end">
            <Col md={5}>
                <Form.Group>
                <Form.Label>Seleccionar usuario a quitar</Form.Label>
                <Form.Select
                    value={usuarioAQuitar}
                    onChange={(e) => setUsuarioAQuitar(e.target.value)}
                >
                    <option value="">-- Seleccione usuario del organigrama --</option>
                    {estructura.map((n) => (
                    <option key={n.usuario_id} value={n.usuario_id}>
                        {n.cargo} - {n.nombre}
                    </option>
                    ))}
                </Form.Select>
                </Form.Group>
            </Col>
            <Col md={2} className="d-flex gap-2">
                <Button
                variant="danger"
                className="w-100"
                onClick={quitarUsuario}
                disabled={!usuarioAQuitar}
                >
                Quitar
                </Button>
                {mostrarGuardarQuitar && (
                <Button
                    variant="primary"
                    onClick={() => {
                    guardarEstructura();
                    setMostrarGuardarQuitar(false);
                    }}
                >
                    Guardar
                </Button>
                )}
            </Col>
            </Row>
        </Card.Body>
        </Card>

        <h5 className="fw-bold mt-5 mb-3">Vista Organigrama</h5>
        <div className="d-flex justify-content-center overflow-auto">
        <Tree
            label={<StyledNode>MORONI</StyledNode>}
            lineWidth={"2px"}
            lineColor={"#ccc"}
            lineBorderRadius={"5px"}
            nodePadding={"15px"}
        >
            {renderTree()}
        </Tree>
        </div>
    </div>
  );
};

export default Organigrama;
